module.exports = __webpack_public_path__ + "static/media/ryan_kim.a2c4a64e.png";